import { render, staticRenderFns } from "./rowCardComponent.vue?vue&type=template&id=8774f3e0"
import script from "./rowCardComponent.vue?vue&type=script&lang=js"
export * from "./rowCardComponent.vue?vue&type=script&lang=js"
import style0 from "./rowCardComponent.vue?vue&type=style&index=0&id=8774f3e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports